import React from "react";
const eliminarIcon = require("assets/img/icons/borrar.png");

export const ClientesAsociadosTable = ({ consumidorFinalForm }) => {
    const { clientesAsociados, QuitarCliente } = consumidorFinalForm;

    return (
        <div className="new-table-wrapper consumidor-final-form__table-wrapper">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th>Cliente</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {clientesAsociados.length === 0 && (
                        <tr>
                            <td colSpan={2} className="text-center">
                                No hay clientes asignados
                            </td>
                        </tr>
                    )}
                    {clientesAsociados.map((cliente) => {
                        return (
                            <tr key={cliente.id}>
                                <td className="text-center">
                                    {cliente.nombre}
                                </td>
                                <td className="text-center">
                                    <div className="table-actions">
                                        <img
                                            src={eliminarIcon}
                                            alt="Quitar"
                                            className="action_img"
                                            title="Quitar"
                                            onClick={() =>
                                                QuitarCliente(cliente)
                                            }
                                        />
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};
